import React from "react";
import { AdminMember } from "../../features/admin/models/AdminUserMembers";
import AdminBlockToggle from "./AdminBlockToggle";

const formatDate = (date: Date): string =>
  new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(date);

interface AdminMembersListProps {
  members: AdminMember[];
}

/** The members of one instructor's organization, newest first (back office; Block is its one action, US-111). */
const AdminMembersList: React.FC<AdminMembersListProps> = ({ members }) => {
  if (members.length === 0) {
    return (
      <div className="with-border rounded-2xl p-8 text-center text-grey-40 dark:text-grey-70">
        No members yet.
      </div>
    );
  }

  return (
    <div className="space-y-2 lg:space-y-4">
      {members.map((member) => (
        <div
          key={member.id}
          className="with-border flex flex-wrap items-center justify-between gap-3 rounded-2xl p-4 lg:p-6"
        >
          <div className="min-w-0">
            <p className="truncate font-semibold text-grey-10 dark:text-white">
              {`${member.firstName} ${member.lastName}`.trim()}
            </p>
            {member.email && (
              <p className="truncate text-sm text-grey-40 dark:text-grey-70">{member.email}</p>
            )}
            <p className="mt-1 text-xs text-grey-50 dark:text-grey-60">
              Added {formatDate(member.dateCreated)}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {member.isMinor && (
              <span className="rounded-full bg-secondary-90 dark:bg-secondary-20 px-3 py-1 text-xs font-medium text-secondary-20 dark:text-secondary-90">
                Minor
              </span>
            )}
            {member.tags.map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-grey-90 dark:bg-primary-20 px-3 py-1 text-xs font-medium text-grey-30 dark:text-grey-70"
              >
                {tag}
              </span>
            ))}
            <AdminBlockToggle
              kind="Member"
              principalId={member.id}
              name={`${member.firstName} ${member.lastName}`.trim()}
              block={member.block}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminMembersList;
